import { Props } from './Layout'
import { useLoginUser } from '../../../../states/LoginUser'
import {
  useArdadeMachineManagerHeaderImageQuery,
  useArcadeMachinesInstallationStatusQuery,
  NftState,
} from '../../query.generated'
import { DISABLED_AMS } from '@/src/assets/constants'

export const useProps = (): Props => {
  const userId = useLoginUser().loginUser?.id ?? ''
  const arcadeMachine = useArdadeMachineManagerHeaderImageQuery({
    variables: {
      where: {
        destroyedAt: { equals: null },
        feverSparkRemain: { not: { equals: 0 } },
        game: { notIn: DISABLED_AMS },
        state: { equals: NftState.InAkiverse },
      },
      take: 1,
    },
  }).data?.arcadeMachines[0]

  const installationStatusResult = useArcadeMachinesInstallationStatusQuery({
    variables: {
      allAmCountWhereInput: {
        game: { notIn: DISABLED_AMS },
        userId: { equals: userId },
        destroyedAt: null,
      },
      installedAmCountWhereInput: {
        game: { notIn: DISABLED_AMS },
        userId: { equals: userId },
        destroyedAt: null,
        gameCenterId: { not: { equals: null } },
      },
      playCountWhereInput: { playSession: { is: { arcadeMachineOwnerId: { equals: userId } } } },
      craftCountWhereInput: { userId: { equals: userId } },
    },
  })

  const amCount = installationStatusResult.data?.allAmCount._count?.id || 0
  const installedCount = installationStatusResult.data?.installedAmCount._count?.id || 0

  return {
    userName: useLoginUser().loginUser?.name ?? '',
    headerImageUrl: arcadeMachine?.metadata.withoutAccImageUrl ?? '',
    maxEnergy: arcadeMachine?.maxEnergy ?? 0,
    energy: arcadeMachine?.energy ?? 0,
    extractedEnergy: arcadeMachine?.extractedEnergy ?? 0,
    feverSparkRemain: arcadeMachine?.feverSparkRemain ?? null,
    HistoricalPerformanceProps: {
      visibleNodata: true,
      chartValus: [],
      onSelected() {},
      target: 'AvarageOccupancyRateOfAmSlots',
    },
    InstallationStatusProps: {
      visibleNoData: false,
      datas: [
        {
          titleKey: 'installationRate',
          value: amCount === 0 ? '0' : ((installedCount / amCount) * 100).toFixed(2),
          suffix: '%',
        },
        {
          titleKey: 'plays',
          value: installationStatusResult.data?.playCount._count?.id || 0,
          isComma: true,
        },
        {
          titleKey: 'craftsExecuted',
          value: installationStatusResult.data?.craftCount._count?.id || 0,
          isComma: true,
        },
      ],
    },
  }
}
